module.exports = __webpack_public_path__ + "img/header.9613dc0.jpg";